export function updateRoute(route, path) {
  return {
    type: "UPDATE_ROUTE",
    route,
    path
  };
}

export function select(name, object) {
  return {
    type: "SELECT_OBJECT",
    name,
    object
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions.js